var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileApps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #3b2a3b;\n      }\n\n      .st2 {\n        fill: #ea275c;\n      }\n\n      .st3 {\n        fill: #fff;\n      }\n\n      .st4 {\n        fill: #dbafbd;\n      }\n\n      .st5 {\n        clip-path: url(#mobile_apps-clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "mobile_apps-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 36.1,
    y: 47,
    width: 119.9,
    height: 118
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_235",
    className: "st3",
    d: "M101.8,3.4C63.5,13.7,44.2,43.1,27,68.2,7.3,96.9-3.3,112.4.9,131.2c5.1,23,28.7,35.2,42,42,32.2,16.6,95.4,32.2,128.4-.6C218.3,125.9,176.9,10,130,.6c-7.6-1.5-18.1,0-28.2,2.8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_179"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2351",
    "data-name": "Trac\\xE9_235",
    className: "st4",
    d: "M108.6,48.8c-20.1,5.4-30.2,20.8-39.2,34-10.3,15.1-15.9,23.2-13.7,33.1,2.7,12.1,15,18.4,22,22,16.9,8.7,50,16.9,67.3-.3,24.6-24.5,3-85.3-21.6-90.2-4-.8-9.5,0-14.8,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_236",
    className: "st4",
    d: "M43.7,92.2c4.2-.4,6.7-3.1,9-5.4,2.6-2.6,4-4.1,3.9-6.1-.1-2.5-2.4-4.2-3.6-5.1-3.1-2.3-9.4-5.1-13.4-2.2-5.7,4-3.5,16.9,1.2,18.7,1,.3,2,.4,3,.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_237",
    className: "st1",
    d: "M88.6,164.9l39.1-8.2c3.8-.9,6.1-4.6,5.2-8.4l-15.6-74.6c-.7-3.8-4.4-6.3-8.2-5.6l-39.1,8.2c-3.8.9-6.1,4.6-5.2,8.4l15.6,74.6c.7,3.8,4.4,6.3,8.2,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_238",
    className: "st3",
    d: "M115.1,79.5l2.7,13.1,2.1,10.3,2.7,13.1,1.8,8.6,3.7,17.6c.5,2.5-.6,5-2.7,6.3-.2,0-.3.2-.5.3-.5.2-.9.4-1.4.5l-9,1.9-7.1,1.5h-.3c0,0-.2.1-.2.1h-.2s-3,.7-3,.7l-6.1,1.3-8.2,1.7c-3.2.7-6.4-1.4-7.1-4.6h0s-1.4-6.8-1.4-6.8l-1.7-8.1-2.4-11.7-7.5-36.1c-.7-3.2,1.4-6.4,4.6-7.1,0,0,0,0,0,0l3.3-.7,30.8-6.4c3.2-.7,6.4,1.4,7.1,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_239",
    className: "st4",
    d: "M117.8,92.7l2.1,10.3c-1.2.3-2.5.4-3.7.5-2.2.1-4.3,0-6.5.3-3.3.4-6.5,1.7-9.1,3.8-.8.6-1.5,1.4-2,2.3-.8,1.7-.5,3.7-.5,5.5.2,4,.2,8.2-1.2,12-1.2,3.4-3.4,6.5-6.3,8.8-1.7,1.3-3.6,2.3-5.3,3.5-1.5,1.1-2.8,2.5-3.7,4-.3.4-.5.9-.7,1.3l-1.7-8.1c.8-.8,1.6-1.5,2.4-2.2,2.5-2.2,5.3-4.1,7.3-6.8,1-1.4,1.7-3,2.1-4.6.4-1.9.4-3.9.6-5.9.5-3.5,2.3-6.6,5-8.9,2.9-2.7,6.5-4.3,10-6,1.8-.9,3.6-1.9,5.2-3.2,1.3-1,2.6-2.2,3.7-3.5.8-1,1.6-2,2.3-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_240",
    className: "st2",
    d: "M124.3,88.8l2.8,13.1c.3,1.5-.6,3-2.2,3.4l-13.1,2.8s0,0-.1,0c-1.5.2-2.9-.7-3.2-2.2l-2.8-13.1c-.3-1.5.6-3,2.2-3.4,0,0,0,0,0,0l13.1-2.8c1.5-.3,3,.6,3.4,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_241",
    className: "st2",
    d: "M135.2,123.7l.3,13.3c0,1.3-.8,2.5-2.1,2.8-.2,0-.4,0-.7,0l-13.3.3h-.2c-1.5,0-2.7-1.3-2.7-2.8l-.3-13.3c0-1.6,1.2-2.9,2.8-2.9,0,0,0,0,0,0l13.3-.3c1.6,0,2.9,1.2,2.9,2.8,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_242",
    className: "st2",
    d: "M99,89.9l1.1,13.3c.1,1.6-1,2.9-2.6,3.1,0,0,0,0,0,0l-13.3,1.1s-.1,0-.2,0c-1.5,0-2.8-1.1-2.9-2.6l-1.1-13.3c-.1-1.6,1-2.9,2.6-3.1l13.3-1.1c1.6-.1,2.9,1,3.1,2.6,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_243",
    className: "st2",
    d: "M96,67.5l3.7,9.2c.4.9,0,1.9-.7,2.5-.1,0-.3.2-.4.2l-9.2,3.7s0,0-.1,0c-1.1.4-2.2-.2-2.6-1.2l-3.7-9.2c-.4-1.1,0-2.3,1.2-2.7,0,0,0,0,0,0l9.2-3.7c1.1-.4,2.3,0,2.7,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_244",
    className: "st2",
    d: "M76.2,57.2l-.4,6.9c0,.7-.5,1.2-1.2,1.4-.1,0-.2,0-.3,0l-6.9-.4s0,0,0,0c-.8,0-1.3-.8-1.3-1.5l.4-6.9c0-.8.7-1.4,1.5-1.4l6.9.4c.8,0,1.4.7,1.4,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_245",
    className: "st2",
    d: "M106,113l3.7,12.8c.4,1.5-.4,3.1-1.9,3.5,0,0,0,0,0,0l-12.8,3.7s0,0-.1,0c-1.5.3-2.9-.5-3.4-2l-3.7-12.8c-.4-1.5.4-3.1,1.9-3.5,0,0,0,0,0,0l12.8-3.7c1.5-.4,3.1.4,3.5,1.9,0,0,0,0,0,0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileApps);
export default __webpack_public_path__ + "static/media/mobile_apps.eb6d2d7d2d4f7283a9d4c4e3d7bcfb11.svg";
export { ForwardRef as ReactComponent };